<template>
	<PageContainer>
		<AmeliproCard no-card-header>
			<!--Ecoute l'evt filter-changed pour mettre à jour via updateListeGarde -->
			<RechercheGarde
				ref="rechercheGarde"
				:recherche-dpa="true"
				@filter-changed="appliquerFiltres"
				@afficher-tableau-resultat="handleFilterChange"
			/>
		</AmeliproCard>
		<AmeliproCard no-card-header>
			<RecapitulatifGarde />
			<ListeGardeByUser
				:filtered-gardes-local="computedFilteredGardes"
				:recherche-garde="false"
				:afficher-detail="false"
				:afficher-tableau-resultat="afficherTableauResultat"
				:titre="titre"
				:statut-filtre="statutFiltre"
				@resultats-disponibles="miseAJourChampsRecherche"
			/>
		</AmeliproCard>
	</PageContainer>
</template>

<script lang="ts">
	import Component, { mixins } from 'vue-class-component';
	import UserMixin from '@/mixins/userMixin';
	const MixinsDeclaration = mixins(UserMixin);
	import { Meta, MetaInfo } from '@/decorators';
	import RechercheGarde from '@/components/garde/RechercheGarde.vue';
	import ListeGardeByUser from '@/components/garde/ListeGardeByUser.vue';
	import RecapitulatifGarde from '@/views/Garde/RecapitulalifGarde.vue';
	import { Garde } from '@/services/api/types';
	import { TYPE_STATUT } from '@/services/constantes';

	@Component({
		components: {
			ListeGardeByUser,
			RechercheGarde,
			RecapitulatifGarde
		}
	})
	export default class DpaDeclaration extends MixinsDeclaration {
		/* istanbul ignore next */
		@Meta
		metaInfo(): MetaInfo {
			return {
				title: 'PEGASE - Demande de paiement (DPA)' as string
			};
		}

		titre = 'Sélectionnez les gardes sur lesquelles vous souhaitez agir';
		statutFiltre = TYPE_STATUT.A_VALIDER;
		afficherTableauResultat = true;
		filteredGardes: Garde[] = [];

		// Propriété calculée pour obtenir les gardes filtrées
		get computedFilteredGardes(): Garde[] {
			if (this.filteredGardes.length > 0) {
				this.afficherTableauResultat = true;
			}
			return this.filteredGardes;
		}

		handleFilterChange(): void {
			this.afficherTableauResultat = false;
		}

		miseAJourChampsRecherche(): void {
			const rechercheGarde = this.$refs.rechercheGarde as
				| RechercheGarde
				| undefined;
			if (rechercheGarde) {
				rechercheGarde.genereFiltres();
			}
		}
	}
</script>
